import * as React from 'react';
import { Box, Stack, Tab, Tabs } from '@mui/material'
import { Children, Fragment, useEffect } from 'react'
import { useTidalStories } from '../TidalStoriesProvider.js'
import { ScrollableContent } from './ScrollableContent.js'
import { TabPanel } from './TabPanel.js'
import type { ToolsProps as Props } from './types.js'
import { useTools } from './useTools.js'

export function Tools(props: Props) {
  const { children, placement } = props

  const { globalControlsConfig } = useTidalStories()
  const config = globalControlsConfig[placement]
  const showTabs = !config?.hideTabs

  const { onChangeTool, tools, activeTool } = useTools(children)

  const childrenCount = Children.count(children)

  // biome-ignore lint/correctness/useExhaustiveDependencies: `childrenCount` must trigger a re-run of the effect
  useEffect(() => {
    const currentTool = tools.find(t => t.props.id === activeTool)

    if (!currentTool) {
      onChangeTool({}, tools[0]?.props.id)
    }
  }, [childrenCount, activeTool, onChangeTool, tools])

  return (
    <Stack height="100%" width="100%" data-id="tidal-stories-tools">
      {showTabs ? (
        <>
          <Box flex="0 0 auto" sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={activeTool} onChange={onChangeTool}>
              {tools.map(tool => (
                <Tab value={tool.props.id} label={tool.props.label} key={tool.props.id} />
              ))}
            </Tabs>
          </Box>

          <ScrollableContent>
            {tools.map(tool => (
              <TabPanel value={activeTool} id={tool.props.id} key={tool.props.id}>
                {tool.props.children}
              </TabPanel>
            ))}
          </ScrollableContent>
        </>
      ) : (
        tools.map(tool => <Fragment key={tool.props.id}>{tool.props.children}</Fragment>)
      )}
    </Stack>
  )
}
